import React from "react";
import styled from "styled-components";
import backgroundImage from "../../../../images/muze-bg.png";

export default styled.section`
    background-size: cover !important;
    width: 100%;
    height: 100%;
    background: url("${backgroundImage}") center center;
    position: fixed;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    // outline: 1px solid red;
    
    @media(max-width: 768px) {
       overflow-y: scroll;
       
       .terms-conditions {
            position: relative;
            bottom: auto;
            right: auto;
    text-align: right;
    display: block;
    margin-right: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
       }
    } 
`;
